import React from 'react';
import { Grid, Space, Typography, theme } from 'antd';

const { Text } = Typography;
const { useBreakpoint } = Grid;

interface InfoRowProps {
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
  /** Renders the value muted, e.g. for "Not provided" placeholders. */
  muted?: boolean;
}

/**
 * Label/value row used by the candidate and metadata sections of summary pages.
 */
export function InfoRow({ icon, label, value, muted = false }: InfoRowProps) {
  const { token } = theme.useToken();
  // Phones stack the value under the label, so long values do not wrap into a thin right column.
  const stacked = useBreakpoint().sm === false;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: stacked ? 'column' : 'row',
        alignItems: stacked ? 'flex-start' : 'center',
        justifyContent: 'space-between',
        gap: stacked ? token.marginXXS : token.marginMD,
        padding: `${token.paddingXS}px ${token.paddingSM}px`,
        borderRadius: token.borderRadius,
        border: `1px solid ${token.colorBorderSecondary}`,
        background: token.colorFillQuaternary,
      }}
    >
      <Space size={8} style={{ flexShrink: 0 }}>
        <span style={{ color: token.colorTextSecondary }}>{icon}</span>
        <Text type="secondary">{label}</Text>
      </Space>
      <Text
        strong={!muted}
        type={muted ? 'secondary' : undefined}
        style={{ textAlign: stacked ? 'left' : 'right', minWidth: 0, wordBreak: 'break-word' }}
      >
        {value}
      </Text>
    </div>
  );
}

export default InfoRow;
